module.exports = __webpack_public_path__ + "static/media/10-10.f606429c.mp3";